import { render } from "./IconBox.vue?vue&type=template&id=757dc0a1&scoped=true"
import script from "./IconBox.vue?vue&type=script&lang=js"
export * from "./IconBox.vue?vue&type=script&lang=js"

import "./IconBox.vue?vue&type=style&index=0&id=757dc0a1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757dc0a1"]])

export default __exports__